import * as types from '../actions/action-types';

const initialState = {
  notifications: [],
  fetchingNotifications: false,
  errorFetchingNotifications: null
};

export default (state = initialState, action) => {
  switch(action.type) {
    case types.NOTIFICATIONS_REQUEST_LIST_FULFILLED:
      return {
        ...state,
        notifications: action.payload,
        fetchingNotifications: false,
        errorFetchingNotifications: null
      };

    case types.NOTIFICATIONS_REQUEST_LIST_PENDING:
      return {
        ...state,
        fetchingNotifications: true,
        errorFetchingNotifications: null
      };

    case types.NOTIFICATIONS_REQUEST_LIST_REJECTED:
      return {
        ...state,
        fetchingNotifications: false,
        errorFetchingNotifications: action.payload
      };

    case types.NOTIFICATION_ACCEPT_FULFILLED:
      return {
        ...state,
        notifications: state.notifications.filter((notif) => notif.id !== action.meta.notification.id)
      };

    case types.NOTIFICATION_DECLINE_FULFILLED:
      return {
        ...state,
        notifications: state.notifications.filter((notif) => notif.id !== action.meta.notification.id)
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/notifications-reducer.js